export const cartEntry = (product, qty) => {
  const img = product.images?.[0] || {};
  return {
    product_id: product.id, slug: product.slug, name: product.name, image: img.thumb || img.url || "",
    price: product.price, mrp: product.mrp, stock: product.stock, qty,
  };
};

export const addCheck = (items, product, qty) => {
  const current = items.find((i) => i.product_id === product.id)?.qty || 0;
  const next = Math.min(current + qty, product.stock);
  if (next > current) return { ok: true, capped: next < current + qty, qty: next };
  if (product.stock <= 0) return { ok: false, message: "This product is out of stock." };
  return { ok: false, message: `Only ${product.stock} available, and they're already in your cart.` };
};

export const upsert = (items, entry) => {
  if (!items.some((i) => i.product_id === entry.product_id)) return [...items, entry];
  return items.map((i) => (i.product_id === entry.product_id ? entry : i));
};

const clampQty = (item, qty) => Math.max(1, Math.min(qty, item.stock > 0 ? item.stock : qty));

export const withQty = (items, id, qty) => items.map((i) => (i.product_id === id ? { ...i, qty: clampQty(i, qty) } : i));

export const without = (items, id) => items.filter((i) => i.product_id !== id);

const syncLine = (item, line) => {
  const qty = line.available > 0 ? Math.min(item.qty, line.available) : item.qty;
  if (line.available === item.stock && line.unit_price === item.price && qty === item.qty) return item;
  return { ...item, stock: line.available, price: line.unit_price, qty };
};

export const syncLines = (items, lines) => {
  const next = items.map((i) => {
    const line = lines.find((l) => l.product_id === i.product_id);
    return line ? syncLine(i, line) : i;
  });
  return next.some((i, idx) => i !== items[idx]) ? next : items;
};

export const cartCount = (items) => items.reduce((n, i) => n + i.qty, 0);
